export function extractFieldErrors(error) {
  const detail = error?.response?.data?.detail;
  if (!Array.isArray(detail)) return [];
  return detail
    .map((item) => {
      const field = Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : undefined;
      return { field, message: item.msg };
    })
    .filter((e) => e.field);
}

export function extractErrorMessages(error) {
  const detail = error?.response?.data?.detail;

  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        const message = item?.msg;
        if (!message) return undefined;
        const field = Array.isArray(item?.loc) ? item.loc[item.loc.length - 1] : undefined;
        return field ? `${field}: ${message}` : message;
      })
      .filter(Boolean);
  }

  const detailMessage = typeof detail === 'string' ? detail : undefined;
  const fallbackMessage =
    detailMessage ||
    (typeof error?.response?.data?.message === 'string' ? error.response.data.message : undefined) ||
    (typeof error?.message === 'string' ? error.message : undefined);

  return fallbackMessage ? [fallbackMessage] : [];
}
